import moment from 'moment'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * 格式化日期
 * @param string
 * @returns {string}
 */
export function dateCommon(string) {
  if (string) {
    return moment(string).format('YYYY/MM/DD')
  } else {
    return ''
  }
}

/**
 * 格式化分钟和秒
 * @param string
 * @returns {string}
 */
export function timeCommon(string) {
  if (string) {
    return moment(string).format('HH:mm:ss')
  } else {
    return ''
  }
}

export function datetimeCommon(string) {
  return moment(string).format('YY/MM/DD HH:mm')
}

/**
 * 格式化分钟和秒
 * @returns {string}
 * @param zone
 * @param givenDate
 */
export function getLocalTime(zone, givenDate) {
  if (givenDate) {
    var given_ms = new Date(givenDate).getTime()
    var d = new Date()
    var offset_ms = d.getTimezoneOffset() * 60 * 1000
    var utc_ms = given_ms + offset_ms
    var target_ms = utc_ms + (zone * 60 * 60 * 1000)
    var dateTime = timestampToYMDHMS(target_ms)
    return dateTime
  } else {
    return ''
  }
}

function timestampToYMDHMS(timestamp) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  const YMDHMS = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  return YMDHMS
}
/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}


/**
 * 金额千分位格式化
 * @param {number|string} value - 金额
 * @param {number} decimals - 保留小数位数（默认2位）
 * @returns {string} 格式化后的字符串
 */
export function formatMoney(value, decimals = 2) {
  if (value === null || value === undefined || value === '') return '0.00'

  const num = Number(value)
  if (isNaN(num)) return value

  // 处理小数部分
  const fixedNum = num.toFixed(decimals)
  const parts = fixedNum.toString().split('.')

  // 处理整数部分千分位
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return parts.join('.')
}
